export function calcSkipNumber(query, len, next) {
    const a = query.skipNumber || 0;
    let b = query.limitNumber === undefined ? len : query.limitNumber;
    if (next) {
        b = Math.min(b, len); // limit how far we can go
    }
    return next ? a + b : a - b;
}
//# sourceMappingURL=skip-calculator.js.map